module.exports = __webpack_public_path__ + "static/media/triangle-right.a059ec33.svg";